"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { EyeIcon } from "@heroicons/react/24/outline";
import type { MouseEvent } from "react";
import { useDropLinkPreviewToggleControl } from "./useDropLinkPreviewToggleControl";
interface WaveDropActionsRestoreLinkPreviewsProps {
  readonly drop: ApiDrop;
  readonly onRestored?: (() => void) | undefined;
}
export default function WaveDropActionsRestoreLinkPreviews(t0) {
  const $ = _c(10);
  const {
    drop,
    onRestored
  } = t0;
  const previewToggle = useDropLinkPreviewToggleControl(drop);
  if (!previewToggle?.isHidden) {
    return null;
  }
  let t1;
  if ($[0] !== onRestored || $[1] !== previewToggle) {
    t1 = event => {
      event.stopPropagation();
      if (previewToggle.isLoading || !previewToggle.canToggle) {
        return;
      }
      previewToggle.onToggle();
      onRestored?.();
    };
    $[0] = onRestored;
    $[1] = previewToggle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  const t2 = previewToggle.isLoading || !previewToggle.canToggle;
  let t3;
  if ($[3] !== previewToggle.isLoading) {
    t3 = previewToggle.isLoading ? <svg className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true"><circle className="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg> : <EyeIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" />;
    $[3] = previewToggle.isLoading;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-text-sm tw-font-medium">Restore link previews</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleClick || $[7] !== t2 || $[8] !== t3) {
    t5 = <button type="button" onClick={handleClick} disabled={t2} className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-iron-300 tw-transition-colors tw-duration-200 disabled:tw-cursor-default disabled:tw-opacity-60 desktop-hover:hover:tw-bg-iron-800" aria-label="Restore link previews">{t3}{t4}</button>;
    $[6] = handleClick;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}